import React, { useEffect, useState } from "react";
import {
  CommonMFE,
  ReactMFE,
  MFE_NAMES,
  Helpers,
} from "@tpd-web-common-libs/nodejs-library";
import {
  ContainerDiv,
  Content,
  Title,
  Menu,
  VoceMenu,
  CTAPreventivoContainer,
  Triangle,
  DropTriangle,
  Dropdown,
  Button,
  PaperDiv,
  Options,
  Option,
  WrapperPaper,
  WrapperDiv,
  MenuContainer,
} from "./App.style";
import styled from "@emotion/styled";
import { OPTIONS } from "./App.setting";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";

import ClickAwayListener from "@mui/material/ClickAwayListener";

const WRAPPER_HEIGHT_DESKTOP = 65;
const FONT_SIZE = 24;
const CONTENT_HEIGHT = WRAPPER_HEIGHT_DESKTOP + FONT_SIZE;
const defaultBackgroundColor = '#308992';

//Serve per evitare che il componente in mobile si sovrapponga al componente inferiore.
// Sarebbe necessario capire se il componente inferiore e sempre unico e nel caso togliergli il margine
// gestendolo da questo componente non solo in mobile ma generalmente
const MOBILE_TOP_MARGIN = CONTENT_HEIGHT - WRAPPER_HEIGHT_DESKTOP;

const App = (props: CommonMFE.Types.TProps) => {
  const {
    __host__,
    config,
    isEditMode,
    contentId,
    projectId,
    id: containerID,
  } = props;

  const title = __host__.pageTitle || 'PAGINA CORRENTE';
  const linkPreventivo = config["Calcola Preventivo Prodotto"];

  /* Handles Dropdown */
  const [open, setOpen] = React.useState(false);
  const [sticky, setSticky] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);
  const stickyContainerRef = React.useRef<HTMLDivElement>(null);
  const stickyContentRef = React.useRef<HTMLDivElement>(null);
  const [menuNames, setMenuNames] = useState([]);
  const [active, setActive] = React.useState(null);
  const [menuItems, setMenuItems] = React.useState<any>();
  const [isOneElement, setIsOneElement] = useState(false);
  const [areMoreThanThreeElements, setAreMoreThanThreeElements] =
    useState(false);
  const [polling, setPolling] = useState(null);
  const [counter, setCounter] = useState(0);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event | React.SyntheticEvent) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event: React.KeyboardEvent) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current!.focus();
    }

    prevOpen.current = open;
  }, [open]);

  /* Fill the array with ids */
  useEffect(() => {
    if (Helpers.EnvironmentHelper.isClientSide()) {
      const setValues = () => {
        const provMenu = Array.prototype.slice.call(
          document.getElementsByClassName("menu-vc-section")
        );
        setIsOneElement(provMenu.length === 0);
        setAreMoreThanThreeElements(provMenu.length > 3);
        setMenuItems(provMenu);
        setMenuNames(provMenu.map((item) => item.id));
        return menuItems;
      }
      if (Helpers.PageHelper.isHCLAuthoringPage()) {
        const polling = setInterval(() => setValues(), 3000);
        setPolling(polling);
      } else {
        setValues();
      }
    }
  }, []);

  useEffect(() => {
    if (menuNames.length > 0) {
      if (counter >= 10) {
        clearInterval(polling);
      }
      setCounter(counter+1);
    }
  }, [menuNames]);

  /* Manage sticky class */
  useEffect(() => {
    if (!Helpers.PageHelper.isHCLAuthoringPage()) {
      const stickyObserver = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && sticky) {
            setSticky(false);
          } else {
            if (entry.boundingClientRect.y < 0 && !sticky) {
              setSticky(true);
            }
          }
        },
        {
          root: null,
          rootMargin: "-65px 0px 0px 0px",
          threshold: 0,
        }
      );
      stickyObserver.observe(stickyContainerRef.current);
      return () => {
        stickyObserver.disconnect();
      };
    } else if (!isEditMode) {
      window.addEventListener('scroll', stickNavbar);

      return () => {
        window.removeEventListener('scroll', stickNavbar);
      };

    }

  }, [
    sticky,
    Array.prototype.slice.call(
      Helpers.EnvironmentHelper.isClientSide() &&
      document.getElementsByClassName("menu-vc-section-container")
    ),
  ]);

  const stickNavbar = () => {
    if (window !== undefined) {
      if (stickyContainerRef.current) {
        if (stickyContainerRef.current.getBoundingClientRect().y < 0) {
          setSticky(true);
        } else {
          setSticky(false);
        }
      }
      
    }
  }

  useEffect(() => {
    if (!Helpers.PageHelper.isHCLAuthoringPage()) {
      if (Helpers.EnvironmentHelper.isClientSide()) {
        const menuItemsObserver = new IntersectionObserver(
          (entry) => {
            entry.forEach((ent) => {
              if (ent.isIntersecting) {
                const result = menuNames.indexOf(ent.target.id);
                if (result !== -1) {
                  setActive(result);
                }
                else if (sticky) { // sto intersecando l'header
                  setSticky(false);
                }
              }
            });
          },
          {
            root: null,
            rootMargin: "0px 0px -95% 0px",
            threshold: 0,
          }
        );
        Array.prototype.slice
          .call(document.getElementsByClassName("menu-vc-section"))
          .forEach((item) => {
            menuItemsObserver.observe(item);
          });
        menuItemsObserver.observe(document.querySelector("[data-mfe-name='tpdHeader']"));
        return () => {
          menuItemsObserver.disconnect();
        };
      }
    } else if (!isEditMode) {
      window.addEventListener('scroll', handleActiveSections);

      return () => {
        window.removeEventListener('scroll', handleActiveSections);
      };
    }

  }, [
    Array.prototype.slice.call(
      Helpers.EnvironmentHelper.isClientSide() &&
      document.getElementsByClassName("menu-vc-section")
    ),
  ]);

  const handleActiveSections = () => {
    if (window !== undefined) {
      if (Helpers.EnvironmentHelper.isClientSide()) {
        const menuItemsPositions = [];
          
        menuItems.forEach((mi, index) => {
          menuItemsPositions.push({value: mi.getBoundingClientRect().y, index: index});
        });

        const provElements = menuItemsPositions.filter(el => el.value <= 0);
        if (provElements.length) {
          const maxValue = Math.max(...provElements.map(y => y.value));
          const activeElement = provElements.find(el => el.value == maxValue);
          setActive(activeElement.index);
        }
      }
    }
  }

  /* Handles click on menu items */
  const handleClick = (index: number) => {
    document.getElementById(menuItems[index].id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <MenuContainer mobileTopMargin={MOBILE_TOP_MARGIN}>
      {Helpers.RemoteHelper.getIsPrimaryVisible(config, isEditMode) && (
        <WrapperDiv
          height={WRAPPER_HEIGHT_DESKTOP}
          negativeMobileTopMargin={MOBILE_TOP_MARGIN}
          className={`${sticky ? "active" : ""}`}
        >
          <ContainerDiv
            defaultColor={defaultBackgroundColor}
            ref={stickyContainerRef}
            className="menu-vc-section-container"
          >
            <Content
              height={CONTENT_HEIGHT}
              fontSize={FONT_SIZE}
              className={`${sticky ? "is-sticky" : ""} ${isOneElement && !sticky ? "one-element" : ""
                }`}
              ref={stickyContentRef}
            >
              <Title>{title}</Title>
              <Menu
                className={`${sticky && areMoreThanThreeElements ? "container-menu" : ""
                  }`}
              >
                {menuNames.map((item, index) => {
                  item =
                    item.toLowerCase() === "trova"
                      ? "Trova l'agenzia"
                      : item.charAt(0).toUpperCase() + item.slice(1);
                  if (item !== "") {
                    return (
                      <VoceMenu
                        key={index}
                        className={`${active === index ? "active" : ""} ${areMoreThanThreeElements && !sticky
                          ? "more-elements"
                          : ""
                          }`}
                        onClick={() => handleClick(index)}
                      >
                        {item}
                        {active === index && <Triangle />}
                      </VoceMenu>
                    );
                  }
                })}
              </Menu>
              <Dropdown>
                {sticky ? (
                  linkPreventivo?.value?.linkElement?.destination?.value !==
                    "" ? (
                    <CTAPreventivoContainer id="calcolo_btn">
                      <ReactMFE.Remote
                        id={CommonMFE.generateID(
                          containerID,
                          `tpd-prodotto-menu-secondario-${MFE_NAMES.tpdCta}`
                        )}
                        __deps__={React}
                        __host__={__host__}
                        __mfeName__={MFE_NAMES.tpdCta}
                        isEditMode={isEditMode}
                        {...linkPreventivo}
                      />
                    </CTAPreventivoContainer>
                  ) : (
                    ""
                  )
                ) : (
                  <Button
                    ref={anchorRef}
                    id="composition-button"
                    aria-controls={open ? "composition-menu" : undefined}
                    aria-expanded={open ? "true" : undefined}
                    aria-haspopup="true"
                    onClick={handleToggle}
                    className="icon-Share"
                  />
                )}
                {open && !sticky ? (
                  <WrapperPaper>
                    <PaperDiv className="popup-container-social">
                      <ClickAwayListener onClickAway={handleClose}>
                        <Options
                          id="composition-menu"
                          aria-labelledby="composition-button"
                          onKeyDown={handleListKeyDown}
                        >
                          <DropTriangle />
                          {OPTIONS.map((item) => {
                            return (
                              <Option
                                key={item.id}
                                onClick={() => {
                                  item.action(config, __host__.url);
                                  setOpen(false);
                                }}
                                className={item.iconClass}
                              />
                            );
                          })}
                        </Options>
                      </ClickAwayListener>
                    </PaperDiv>
                  </WrapperPaper>
                ) : (
                  ""
                )}
              </Dropdown>
            </Content>
          </ContainerDiv>
        </WrapperDiv>
      )}
    </MenuContainer>
  );
};

export default ReactMFE.PrimaryRemoteHOCFactory(
  React,
  styled,
  { CacheProvider },
  createCache
)(App);
